export default {
  covidData: [],
  totalConfirmedData: []
}
